export default "__VITE_ASSET__Cztmaj8l__"